"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.save = exports.refresh = exports.get = exports.forgeTokenData = exports.clear = void 0;
var _cookies = require("@kiwicom/cookies");
var utils = _interopRequireWildcard(require("./utils"));
var web = _interopRequireWildcard(require("./web"));
var mobile = _interopRequireWildcard(require("./mobile"));
var fakeMobile = _interopRequireWildcard(require("./fakeMobile"));
var webLegacy = _interopRequireWildcard(require("./webLegacy"));
var _utils2 = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const forceFakeMobileCookie = "dev_su2_force_cookies";
const isLegacy = () => {
  const legacyToken = webLegacy.get();
  if (legacyToken.accessToken.data !== null) {
    return true;
  }
  return false;
};
const forceLegacy = () => {
  if ((0, _utils2.isTequila)()) {
    return true;
  }
  if ((0, _utils2.isWebview)()) {
    const tokenData = webLegacy.get();
    if (tokenData.accessToken.data !== null) {
      return true;
    }
  }
  return false;
};
const forceFakeMobile = () => {
  const forceFakeMobileCookieValue = (0, _cookies.load)(forceFakeMobileCookie);
  if ((0, _utils2.isWebview)() && forceFakeMobileCookieValue === "true") {
    return true;
  }
  return false;
};
const forgeTokenData = (accessToken, refreshToken) => {
  const tokenData = utils.emptyTokenData();
  tokenData.accessToken = utils.decodeToken(accessToken);
  if (refreshToken !== null) {
    tokenData.refreshToken = utils.decodeToken(refreshToken);
  }
  return tokenData;
};

// eslint-disable-next-line require-await
exports.forgeTokenData = forgeTokenData;
const get = async () => {
  if (forceLegacy()) {
    return webLegacy.get();
  }
  if (forceFakeMobile()) {
    return fakeMobile.get();
  }
  if ((0, _utils2.isWebview)()) {
    return mobile.get();
  }
  if (isLegacy()) {
    return webLegacy.get();
  }
  return web.get();
};

// eslint-disable-next-line require-await
exports.get = get;
const save = async tokenData => {
  if (forceLegacy()) {
    return webLegacy.save(tokenData);
  }
  if (forceFakeMobile()) {
    return fakeMobile.save(tokenData);
  }
  if (!(0, _utils2.isWebview)()) {
    return web.save(tokenData);
  }
  return Promise.resolve();
};

// eslint-disable-next-line require-await
exports.save = save;
const refresh = async tokenData => {
  if (forceLegacy()) {
    return tokenData;
  }
  if (forceFakeMobile()) {
    return fakeMobile.refresh(tokenData);
  }
  if ((0, _utils2.isWebview)()) {
    return mobile.refresh();
  }
  if (isLegacy()) {
    return webLegacy.exchange(tokenData);
  }
  return web.refresh(tokenData);
};

// eslint-disable-next-line require-await
exports.refresh = refresh;
const clear = async () => {
  if (forceLegacy()) {
    return webLegacy.clear();
  }
  if (forceFakeMobile()) {
    return fakeMobile.clear();
  }
  if (!(0, _utils2.isWebview)()) {
    return web.clear();
  }
  return Promise.resolve();
};
exports.clear = clear;